export default {
  initialised: false,
  pageLoading: false,
  branding: {},
  system: { external_data: [] },
  digitalHubLink: null,
  currentProperty: {},
  propertyEnums: {},
  property24: {
    provinces: [],
    cities: {},
    suburbs: {}
  },
  profile: null,
  profile_v2: null,
  activeProperties: null,
  toast: {},
  userOfficeList: {},
  selectedOffice: {},
  menus: [],
  pagesLoading: false,
  pages: [],
  articles: [],
  referralTerms: null,
  admin: [],
  notifications: null,
  videoBrandingTool: {
    callToActionItems: [
      { id: 0, title: 'Hide' },
      { id: 1, title: 'Show' }
    ]
  },
  savingBrandingPresets: null,
  selectedVideoBradingOption: {
    logo: null,
    branding: { id: null },
    transition: null,
    backingMusic: [],
    showPresenter: true,
    // brandingOption: null,
    // callToAction: null,
    // audio: null,
    // presenter: null,
    mergeVideoette: null
  },
  videoettes: {
    propertyVideos: {},
    logoItems: [],
    transitionItems: [],
    brandingItems: [],
    backingMusicItems: []
  },
  availabilityTimes: {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: []
  },
  marketingPackNotifications: {
    orders: 0,
    notifications: 0
  },
  annualReview: {},
  potentialReferralCount: 0
}
